// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datasource-modal .modal-body {
  margin-left: 15px;
}

.page-content .data-source {
  margin-left: 0.5em;
  margin-right: 0.5em;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.data-source .btn-primary {
  color: #fff;
  background-color: #265160;
  border-color: #265160;
}

.datasdata-sourceource .btn-primary:hover {
  background-image: none !important;
  background-color: rgba(38, 81, 96, 0.768627451) !important;
}

.data-source .deactivateDash .react-switch-bg {
  background: rgb(39, 83, 98) !important;
}

.data-source .react-switch-handle {
  background: #fff !important;
}

.data-source .GridCustomStyle {
  height: 70vh !important;
}`, "",{"version":3,"sources":["webpack://./../gui/src/public/css/dataSource.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,WAAA;EACA,yBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,iCAAA;EACA,0DAAA;AACJ;;AAEA;EACI,sCAAA;AACJ;;AACA;EACI,2BAAA;AAEJ;;AACE;EACE,uBAAA;AAEJ","sourcesContent":[".datasource-modal .modal-body{\n    margin-left:15px;\n}\n\n.page-content .data-source{\n    margin-left: 0.5em;\n    margin-right: 0.5em;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.data-source .btn-primary{\n    color: #fff;\n    background-color: #265160;\n    border-color: #265160;\n  }\n  \n.datasdata-sourceource .btn-primary:hover{\n    background-image:none !important;\n    background-color:#265160c4 !important;\n  }\n  \n.data-source .deactivateDash .react-switch-bg{\n    background: rgb(39, 83, 98)  !important;\n  }\n.data-source .react-switch-handle{\n    background: #fff !important;\n  }\n\n  .data-source .GridCustomStyle{\n    height: 70vh !important;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
